export default __webpack_public_path__ + "static/media/ve.34ff7eb1.svg";